import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { ClubSelectField } from "./ClubSelectField";
import { ImageUploadField } from "./ImageUploadField";

export function EventForm({ formData, f, managedClubs, api }) {
  return (
    <>
      <ClubSelectField formData={formData} f={f} managedClubs={managedClubs} />
      <div><Label className="text-sm">Titel</Label><Input value={formData.title || ""} onChange={e => f("title", e.target.value)} className="mt-1 bg-input/50 border-white/10 rounded-none" data-testid="dialog-title" /></div>
      <div><Label className="text-sm">Beschreibung</Label><Textarea value={formData.description || ""} onChange={e => f("description", e.target.value)} className="mt-1 bg-input/50 border-white/10 rounded-none" data-testid="dialog-description" /></div>
      <div className="grid grid-cols-2 gap-3">
        <div><Label className="text-sm">Datum</Label><Input type="date" value={formData.date || ""} onChange={e => f("date", e.target.value)} className="mt-1 bg-input/50 border-white/10 rounded-none" data-testid="dialog-date" /></div>
        <div><Label className="text-sm">Uhrzeit</Label><Input type="time" value={formData.time || ""} onChange={e => f("time", e.target.value)} className="mt-1 bg-input/50 border-white/10 rounded-none" data-testid="dialog-time" /></div>
      </div>
      <div><Label className="text-sm">Ende</Label><Input type="time" value={formData.end_time || ""} onChange={e => f("end_time", e.target.value)} className="mt-1 bg-input/50 border-white/10 rounded-none" /></div>
      <ImageUploadField formData={formData} f={f} api={api} />
      <div className="flex items-center gap-2">
        <Switch checked={formData.featured || false} onCheckedChange={v => f("featured", v)} data-testid="dialog-featured" />
        <Label className="text-sm">Featured Event</Label>
      </div>
      <div className="flex items-center gap-2">
        <Switch checked={formData.countdown || false} onCheckedChange={v => f("countdown", v)} data-testid="dialog-countdown" />
        <Label className="text-sm">Countdown anzeigen</Label>
      </div>
      {formData.countdown && (
        <div>
          <Label className="text-sm">Countdown Stunden vorher</Label>
          <Input type="number" min="1" max="720" value={formData.countdown_hours || ""} onChange={e => f("countdown_hours", parseInt(e.target.value) || 0)}
            className="mt-1 bg-input/50 border-white/10 rounded-none" data-testid="dialog-countdown-hours" placeholder="z.B. 24" />
        </div>
      )}
      <div className="border-t border-white/10 pt-3 mt-1 space-y-2">
        <Label className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Verfügbarkeit für Gäste</Label>
        <div className="flex items-center gap-2">
          <Switch checked={formData.billard_available !== false} onCheckedChange={v => f("billard_available", v)} data-testid="dialog-billard-available" />
          <Label className="text-sm">Billard für Gäste verfügbar</Label>
        </div>
        <div className="flex items-center gap-2">
          <Switch checked={formData.edart_available !== false} onCheckedChange={v => f("edart_available", v)} data-testid="dialog-edart-available" />
          <Label className="text-sm">EDart für Gäste verfügbar</Label>
        </div>
        <div className="flex items-center gap-2">
          <Switch checked={formData.steeldart_available !== false} onCheckedChange={v => f("steeldart_available", v)} data-testid="dialog-steeldart-available" />
          <Label className="text-sm">SteelDart für Gäste verfügbar</Label>
        </div>
      </div>
    </>
  );
}
